import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../common.service';
@Component({
  selector: 'app-view-animal-general',
  templateUrl: './view-animal-general.component.html',
  styleUrls: ['./view-animal-general.component.css']
})
export class ViewAnimalGeneralComponent implements OnInit {
  getanimalgeneralviewApi:any;
  testdate:any;
  birthdate:any;
  datepurchase:any;
  transfdate:any;
  datedelete:any;
  returnUrl="/dashboard/RottweilerDogsAnimalmanagement"
  constructor(private router: Router,private commonService: CommonService) { }

 async ngOnInit() {
    let GeneralId = sessionStorage.getItem('generalId');
    this.getanimalgeneralviewApi= "/animal_management/general/"+GeneralId;
    (await this.commonService.getApi(this.getanimalgeneralviewApi)).subscribe(
      res => { 
        console.log(res.data);
        var date=res.data.tnam_gen_date_of_birth;
        this.birthdate = date.split('T');
        var transferdate=res.data.tnam_gen_date_of_transfer;
       this.transfdate = date.split('T');
        var purchasedate=res.data.tnam_gen_date_of_purchase;
        this.datepurchase = date.split('T');
        var deletiondate=res.data.tnam_gen_date_of_deletion;
        this.datedelete = date.split('T');
        $("#Animaltype").text(res.data.tnam_gen_type),
    //   $("#DiscoveryDate").text(res.data.tnam_dis_date_of_discovery),
       $("#Species").text(res.data.species_name),
       $("#Breed").text(res.data.breed_name),
       $("#Gender").text(res.data.tnam_gen_sex),
       $("#Gender").text(res.data.tnam_gen_sex),
       $("#Age").text(res.data.tnam_gen_age_group),
       $("#Weight").text(res.data.tnam_gen_weight)
      })
  }
  backnavigate(){
    this.router.navigate([this.returnUrl]);
  }

}
